import { useMutation, useQueryClient, mutationOptions } from '@tanstack/react-query';

import { addCompaniesToProspectQuery } from '../../api/companiesApi';
import { addLeadsToEnrichmentQueue, deleteLeads } from '../../api/leadApi';
import { contactPeopleKeys } from '../contactPeople/keys';
import { jobKeys } from '../jobs/keys';
import { prospectQueryKeys } from '../prospectQueries/keys';

import { companiesKeys, companiesMutationKeys } from './keys';

export const addLeadsToEnrichmentQueueOptions = (qc) =>
	mutationOptions({
		mutationKey: companiesMutationKeys.enrich,
		mutationFn: addLeadsToEnrichmentQueue,
		onSuccess: (data, { prospectQueryId }) => {
			qc.invalidateQueries({ queryKey: prospectQueryKeys.all });
			qc.invalidateQueries({ queryKey: jobKeys.byProspectQuery(prospectQueryId) });
		},
	});

export function useAddLeadsToEnrichmentQueue() {
	const qc = useQueryClient();
	return useMutation(addLeadsToEnrichmentQueueOptions(qc));
}

export const deleteLeadsOptions = (queryClient) =>
	mutationOptions({
		mutationKey: companiesMutationKeys.delete,
		mutationFn: deleteLeads,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: companiesKeys.all });
			queryClient.invalidateQueries({ queryKey: contactPeopleKeys.all });
			queryClient.invalidateQueries({ queryKey: prospectQueryKeys.all });
		},
	});

export function useDeleteLeads() {
	const qc = useQueryClient();
	return useMutation(deleteLeadsOptions(qc));
}

/**
 * Mutation to add companies to an existing prospect query
 */
export const addCompaniesToProspectQueryOptions = (queryClient) =>
	mutationOptions({
		mutationKey: companiesMutationKeys.addToQuery,
		mutationFn: ({ prospectQueryId, companies }) => addCompaniesToProspectQuery(prospectQueryId, companies),
		onSuccess: () => {
			// Invalidate all prospect query related queries to refresh the data
			queryClient.invalidateQueries({ queryKey: prospectQueryKeys.all });
			queryClient.invalidateQueries({ queryKey: companiesKeys.all });
		},
	});

export function useAddCompaniesToProspectQuery() {
	const queryClient = useQueryClient();
	return useMutation(addCompaniesToProspectQueryOptions(queryClient));
}
